module.exports = __webpack_public_path__ + "static/media/radio.01c551b8.png";